// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer___yela","footerContent":"Footer_footerContent__rMjYN","textOutlinks":"Footer_textOutlinks___1Vhr","socialLinks":"Footer_socialLinks__BGpFd"};